// Sugalarm — /api/glucose wrappers.

import { request } from "../lib/apiClient";
import type { ApiResult, Reading } from "../lib/types";

export interface LatestResponse {
  reading: Reading | null;
  stale: boolean;
  age_seconds: number | null;
}

export interface HistoryResponse {
  count: number;
  readings: Reading[];
}

// Cycle 433: both reads take an optional `AbortSignal` so the wake reseed
// can BOUND itself — a fetch iOS froze mid-flight otherwise pends for
// minutes and holds the caller's in-flight guard with it.
export function latest(signal?: AbortSignal): Promise<ApiResult<LatestResponse>> {
  return request<LatestResponse>("/api/glucose/latest", { signal });
}

export function history(
  hours = 3,
  limit = 36,
  signal?: AbortSignal,
): Promise<ApiResult<HistoryResponse>> {
  return request<HistoryResponse>(`/api/glucose/history?hours=${hours}&limit=${limit}`, {
    signal,
  });
}
